import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight, Mail, Instagram } from "lucide-react";
import Logo from "../assets/aakaarlogoupdated.png";


export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#050505] border-t border-white/5" data-testid="footer">
      {/* Big CTA Section */}
      <div className="section-padding">
        <div className="container-custom">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
            className="text-center"
          >
            <p className="text-[#A1A1A1] uppercase tracking-[0.3em] text-xs mb-6">
              Ready to elevate your brand?
            </p>
            <h2 className="font-heading text-5xl md:text-7xl lg:text-8xl text-white mb-8">
              Let's <span className="italic text-[#C5A059]">Create</span>
            </h2>
            <a
              href="https://wa.me/918006521008"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary inline-flex items-center gap-3"
              data-testid="footer-whatsapp-cta"
            >
              Start a Project
              <ArrowUpRight size={16} />
            </a>
          </motion.div>
        </div>
      </div>

      {/* Footer Links */}
      <div className="border-t border-white/5 py-12 px-6 md:px-12 lg:px-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-12 md:gap-8">
            {/* Logo & Tagline */}
            <div className="md:col-span-2">
              <Link to="/" data-testid="footer-logo">
                <img
  src={Logo}
  alt="Aakaar Designs"
  className="h-16 w-[185px] object-cover object-left scale-150"
/>
              </Link>
              <p className="text-[#A1A1A1] text-sm leading-relaxed max-w-md">
                Crafting premium digital experiences that elevate brands and
                drive business growth. Where design meets excellence.
              </p>
            </div>

            {/* Navigation */}
            <div>
              <h4 className="text-white text-xs uppercase tracking-[0.2em] mb-6">
                Navigate
              </h4>
              <ul className="space-y-4">
                {["Home", "Work", "Services", "About", "Contact"].map((item) => (
                  <li key={item}>
                    <Link
                      to={item === "Home" ? "/" : `/${item.toLowerCase()}`}
                      className="text-[#A1A1A1] text-sm hover:text-[#C5A059] transition-colors link-underline"
                      data-testid={`footer-nav-${item.toLowerCase()}`}
                    >
                      {item}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact */}
            <div>
              <h4 className="text-white text-xs uppercase tracking-[0.2em] mb-6">
                Connect
              </h4>
              <ul className="space-y-4">
                <li>
                  <a
                    href="mailto:aniket@aakaardesigns.com"
                    className="text-[#A1A1A1] text-sm hover:text-[#C5A059] transition-colors flex items-center gap-2"
                    data-testid="footer-email"
                  >
                    <Mail size={14} />
                    aniket@aakaardesigns.com
                  </a>
                </li>
                <li>
                  <a
                    href="https://instagram.com/aakaardesigns"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-[#A1A1A1] text-sm hover:text-[#C5A059] transition-colors flex items-center gap-2"
                    data-testid="footer-instagram"
                  >
                    <Instagram size={14} />
                    @aakaardesigns
                  </a>
                </li>
                <li>
                  <a
                    href="https://wa.me/918006521008"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-[#A1A1A1] text-sm hover:text-[#C5A059] transition-colors flex items-center gap-2"
                    data-testid="footer-whatsapp"
                  >
                    <svg
                      viewBox="0 0 24 24"
                      fill="currentColor"
                      className="w-3.5 h-3.5"
                    >
                      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
                    </svg>
                    +91 800 652 1008
                  </a>
                </li>
              </ul>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="border-t border-white/5 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-[#A1A1A1] text-xs">
              © {currentYear} Aakaar Designs. All rights reserved.
            </p>
            <p className="text-[#A1A1A1] text-xs">
              Crafted with precision in India
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
